/*
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2026 Pearson Education, Inc.
 * All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 * patent applications, and are protected by trade secret or copyright law.
 * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 * is strictly forbidden unless prior written permission is obtained
 * from Pearson Education, Inc.
 */

import React from 'react';
import PropTypes from 'prop-types';
import { Avatar } from '@mui/material';
import { AIADMIN_PRIMARY_COLOR, AIADMIN_SURFACE_WHITE_HEX_COLOR } from '../../common/styles/aiadminThemeTokens';

/**
 * Maven's avatar: an initial, like a teammate's profile picture, in the dashboard navy.
 * Use `light` on navy surfaces (the floating button, the panel header) so it stays visible.
 */
const MavenAvatar = ({ size, light }) => (
  <Avatar
    alt="Maven"
    sx={{
      width: size,
      height: size,
      fontSize: size * 0.45,
      fontWeight: 700,
      bgcolor: light ? AIADMIN_SURFACE_WHITE_HEX_COLOR : AIADMIN_PRIMARY_COLOR,
      color: light ? AIADMIN_PRIMARY_COLOR : AIADMIN_SURFACE_WHITE_HEX_COLOR
    }}
  >
    M
  </Avatar>
);

MavenAvatar.propTypes = { size: PropTypes.number, light: PropTypes.bool };

MavenAvatar.defaultProps = { size: 32, light: false };

export default MavenAvatar;
